import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import PageLayout from 'components/layout/pageLayout'
import SubNavigation from 'components/layout/subNavigation'
import Head from 'components/layout/head'

interface LinksRigipsProps extends RouteComponentProps<any> {
  authenticated: boolean
  dispatch: any
}

interface ILink {
  href: string
  label: string
}

type LinksRigipsState = {
  links: ILink[]
}

class LinksRigips extends Component<LinksRigipsProps, LinksRigipsState> {
  constructor(props: LinksRigipsProps) {
    super(props)
    this.state = {
      links: [
        {
          href: 'https://www.rigips.at',
          label: 'www.rigips.at',
        },
        {
          href: 'https://www.isover.at',
          label: 'www.isover.at',
        },
        {
          href: 'https://www.at.weber',
          label: 'www.at.weber',
        },
        {
          href: 'http://www.saint-gobain.at',
          label: 'www.saint-gobain.at',
        },
      ],
    }
  }

  render() {
    const { links } = this.state

    return (
      <PageLayout pageTitle="Hilfe">
        <Head headline="Hilfe & Hinweise" subheadline="Mengenermittlung und Systemsuche - HORST" />
        <SubNavigation
          items={[
            {
              label: 'Bedienung',
              link: '/help/manual',
            },
            {
              label: 'Nutzungshinweise',
              link: '/help/terms-of-use',
            },
            {
              label: 'Links',
              link: '/help/links',
            },
            {
              label: 'Impressum',
              link: 'https://www.rigips.at/impressum',
            },
          ]}
        />
        <div className="flex flex-col items-start px-48 mb-65">
          {links.map((link: ILink, index: number) => (
            <a
              key={index}
              className="link mt-10 first-child:mt-0 text-20 tracking-0.23 leading-24"
              target="_blank"
              rel="noopener noreferrer"
              href={link.href}
            >
              {link.label}
            </a>
          ))}
        </div>
      </PageLayout>
    )
  }
}

export default LinksRigips
